import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { getCurrentView } from '../store/selectors/ui';
import { hideOverlayFilters, showOverlayFilters } from '../store/actions/ui';

import ColumnSelector from '../columns/selector';
import ColumnSelectorButton from 'bundles/research/index/components/column_selector_button';
import SidebarSearch from 'components/search_sidebar/sidebar_search';
import CompsSavedSearchTopbar from 'bundles/comps/index/searches/comps_saved_search_topbar.js';
import ViewToggle from 'bundles/comps/index/comps_view_toggle';

export class CompsFilterRow extends React.Component {
  static propTypes = {
    children: PropTypes.any,
    currentView: PropTypes.string.isRequired,
    edgeCrm: PropTypes.bool,
    hideOverlayFilters: PropTypes.func.isRequired,
    hidePageData: PropTypes.bool,
    pageData: PropTypes.shape({
      currentPage: PropTypes.number.isRequired,
      itemCount: PropTypes.number.isRequired,
      itemSingularLabel: PropTypes.string.isRequired,
      pageSize: PropTypes.number.isRequired,
      totalCount: PropTypes.number.isRequired
    }),
    searchFormGroupChildren: PropTypes.any,
    searchPlaceholder: PropTypes.string,
    searchText: PropTypes.string,
    showColumnFilters: PropTypes.bool,
    showOverlayFilters: PropTypes.func.isRequired,
    onSearchChange: PropTypes.func
  }

  static defaultProps = {
    searchPlaceholder: 'Search'
  }

  render() {
    return (
      <div className="px-3">
        <div className="filters-row">
          {this.renderSearchBar()}
          <div className="hidden-xs hidden-sm d-inline-flex">{this.props.children}</div>
        </div>

        {this.props.edgeCrm && this.props.currentView !== 'map' &&
          <ColumnSelectorButton
            className="mx-3"
            hide={!this.props.showColumnFilters}
            onClose={this.props.hideOverlayFilters}
            onOpen={this.props.showOverlayFilters}
          >
            <ColumnSelector/>
          </ColumnSelectorButton>
        }

        {this.props.edgeCrm && <ViewToggle/>}

        {!this.props.edgeCrm &&
          <div className="d-inline-block page-count pull-right">
            <CompsSavedSearchTopbar />
          </div>
        }
      </div>
    );
  }

  renderSearchBar() {
    const { searchPlaceholder, searchText, onSearchChange } = this.props;

    if (!onSearchChange) return null;

    return (
      <SidebarSearch
        name="search_text"
        placeholder={searchPlaceholder}
        value={searchText}
        onChange={onSearchChange}
      >
        {this.props.searchFormGroupChildren}
      </SidebarSearch>
    );
  }
}

const mapStateToProps = state => ({
  currentView: getCurrentView(state),
  showColumnFilters: state.ui.showColumnFilters,
});

const mapDispatchToProps = {
  hideOverlayFilters,
  showOverlayFilters
};

export default connect(mapStateToProps, mapDispatchToProps)(CompsFilterRow);
